function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useRef, useState } from 'react';
import { Alert, AlertDescription, AlertIcon, Box, Flex, icons } from '@tapresearch/ui/components';
import { useLongitudinalQuestionResult, useRootTapAnswersList } from '../../../../api';
import { DotLoader, useFilter, QuestionResultWrapper, GraphToggleSwitch } from '../../../common';
import useAsset from '../../../hook/useAsset';
import { getChartWaveLabels } from '../components/charts/getChartWaveLabels';
import { useFormatResultsData } from '../hooks/useFormatResultsData';
import { ResponsiveLineChart } from './charts';
import { ResponsiveBumpChart } from './charts/ResponsiveBumpChart';
import { ResponsiveRatingLineChart } from './charts/ResponsiveRatingLineChart';
import { QuestionSingleWaveSelect } from './QuestionSingleWaveSelect';
import { SwitchQuestionGraph } from './SwitchQuestionGraph';
import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';
export var LongitudinalQuestion = function(param) {
    var projectIdentifier = param.projectIdentifier, tapQuestion = param.tapQuestion, waves = param.waves;
    var _useAsset = useAsset(), active_enum = _useAsset.active_enum, constants = _useAsset.constants;
    var isRanking = tapQuestion.tap_answer_type === constants.TAP_ANSWER_TYPE_RANKING;
    var tapSurveyIds = waves.filter(function(wave) {
        return wave.attributes.status !== constants.STATUS_DRAFT;
    }).map(function(wave) {
        return wave.attributes.providable_id.toString();
    });
    var filterValues = useFilter().filterValues;
    var _useState = _sliced_to_array(useState(false), 2), groupRcAnswers = _useState[0], setGroupRcAnswers = _useState[1];
    var chartWaveLabels = getChartWaveLabels(waves);
    var _useState1 = _sliced_to_array(useState(true), 2), usePercentage = _useState1[0], setUsePercentage = _useState1[1];
    var _useLongitudinalQuestionResult = useLongitudinalQuestionResult(tapQuestion.identifier, tapSurveyIds, filterValues, groupRcAnswers), tmp = _useLongitudinalQuestionResult.data, _ref = tmp === void 0 ? {} : tmp, result = _ref.attributes, metaData = _ref.meta, refetch = _useLongitudinalQuestionResult.refetch;
    var _ref1 = metaData || {}, answersCount = _ref1.answers_count;
    var _useRootTapAnswersList = useRootTapAnswersList(tapQuestion.identifier), tapAnswers = _useRootTapAnswersList.data;
    var formattedData = useFormatResultsData({
        result: result,
        tapAnswers: tapAnswers,
        questionType: tapQuestion.tap_answer_type,
        chartWaveLabels: chartWaveLabels,
        usePercentage: usePercentage && !isRanking
    }) || [];
    var isUnchartable = [
        constants.TAP_ANSWER_TYPE_FREE_TEXT,
        constants.TAP_ANSWER_TYPE_MESSAGE
    ].includes(tapQuestion.tap_answer_type);
    var questionType = active_enum.TapAnswerType[tapQuestion.tap_answer_type.toString()];
    var wrapperRef = useRef();
    var onChange = useCallback(function() {
        setGroupRcAnswers(!groupRcAnswers);
        refetch();
    }, [
        groupRcAnswers,
        refetch
    ]);
    return /*#__PURE__*/ React.createElement(QuestionResultWrapper, {
        tapQuestion: tapQuestion,
        isLongitudinalView: true,
        headerRightContent: /*#__PURE__*/ React.createElement(Flex, {
            flexDirection: "column"
        }, /*#__PURE__*/ React.createElement(Flex, null, /*#__PURE__*/ React.createElement(QuestionSingleWaveSelect, {
            waves: waves,
            projectIdentifier: projectIdentifier
        })), !isUnchartable && !isRanking && /*#__PURE__*/ React.createElement(Flex, {
            justifyContent: "right",
            mr: 6,
            mt: 2
        }, /*#__PURE__*/ React.createElement(GraphToggleSwitch, {
            leftItem: {
                icon: icons.fi.Percent,
                label: 'Graph by percentages',
                callback: function() {
                    return setUsePercentage(true);
                }
            },
            rightItem: {
                icon: icons.fi.Hash,
                label: 'Graph by respondent totals',
                callback: function() {
                    return setUsePercentage(false);
                }
            },
            selectedItem: usePercentage ? 'left' : 'right'
        })))
    }, !isUnchartable ? /*#__PURE__*/ React.createElement(Flex, {
        "data-testid": "longitudinal-question-chart-wrapper",
        minH: "400px",
        flexGrow: 1,
        align: "center",
        justify: "center",
        ref: wrapperRef
    }, !!formattedData.length ? /*#__PURE__*/ React.createElement(OpacityTransitionBox, {
        w: "100%",
        h: "100%"
    }, /*#__PURE__*/ React.createElement(SwitchQuestionGraph, {
        match: constants.TAP_ANSWER_TYPE_SCALE_RANGE,
        component: ResponsiveRatingLineChart,
        legendDirection: !groupRcAnswers ? 'row' : 'column',
        data: formattedData,
        waves: waves,
        answerType: tapQuestion.tap_answer_type,
        usePercentage: usePercentage,
        customLegendControlProps: {
            isChecked: groupRcAnswers,
            onChange: onChange,
            answersCount: answersCount
        }
    }), /*#__PURE__*/ React.createElement(SwitchQuestionGraph, {
        match: constants.TAP_ANSWER_TYPE_RANKING,
        component: ResponsiveBumpChart,
        data: formattedData,
        answerType: tapQuestion.tap_answer_type
    }), /*#__PURE__*/ React.createElement(SwitchQuestionGraph, {
        match: constants.TAP_ANSWER_TYPE_MULTIPLE_CHOICE,
        component: ResponsiveLineChart,
        data: formattedData,
        waves: waves,
        usePercentage: usePercentage,
        answerType: tapQuestion.tap_answer_type
    }), /*#__PURE__*/ React.createElement(SwitchQuestionGraph, {
        match: constants.TAP_ANSWER_TYPE_IMAGE_CHOICE,
        component: ResponsiveLineChart,
        data: formattedData,
        waves: waves,
        usePercentage: usePercentage,
        answerType: tapQuestion.tap_answer_type
    })) : /*#__PURE__*/ React.createElement(DotLoader, {
        h: 10,
        dotSize: "20px"
    })) : /*#__PURE__*/ React.createElement(Box, {
        mt: 6,
        flexGrow: 1,
        "data-testid": "unchartable-question-notice"
    }, /*#__PURE__*/ React.createElement(Alert, {
        rounded: "none",
        bg: "blue.50",
        py: 3,
        opacity: 1,
        variant: "subtle",
        pl: 8,
        status: "info"
    }, /*#__PURE__*/ React.createElement(AlertIcon, {
        opacity: 0.5,
        color: "blue.500",
        boxSize: 4
    }), /*#__PURE__*/ React.createElement(AlertDescription, {
        color: "gray.500",
        fontSize: "xs",
        fontWeight: "medium"
    }, questionType, " type questions are not able to be graphed."))));
};
